import { useCallback, useEffect, useState } from "react";
import { dashboardAPI } from "../services/api";

export const useGlobalDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [kpis, setKpis] = useState(null);
  const [projects, setProjects] = useState([]);
  const [filteredNcrs, setFilteredNcrs] = useState([]);
  const [activityFeed, setActivityFeed] = useState([]);
  const [charts, setCharts] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const res = await dashboardAPI.getAdminGlobal();
      const data = res.data || {};

      setDashboardData(data.summary || null);
      setKpis(data.kpis || null);
      setProjects(Array.isArray(data.projects) ? data.projects : []);
      setFilteredNcrs(Array.isArray(data.urgent_ncrs) ? data.urgent_ncrs : []);
      setActivityFeed(Array.isArray(data.activity) ? data.activity : []);
      setCharts(data.charts || null);
    } catch (err) {
      console.error("Failed to load global dashboard", err);
      setError(err);

      // fallback so the page doesn't break
      try {
        const fallback = await dashboardAPI.getSummary();
        const s = fallback.data || {};
        setDashboardData({
          total_projects: s.total_projects || 0,
          active_projects: s.active_projects || 0,
          total_inspections: 0,
          completed_inspections: 0,
          open_ncrs: 0,
          pending_rfis: 0,
          critical_findings: 0,
        });
        setProjects(s.active_projects_list || []);
        setKpis(null);
        setFilteredNcrs([]);
        setActivityFeed([]);
      } catch (e2) {
        console.error("Fallback dashboard summary failed", e2);
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    dashboardData,
    kpis,
    projects,
    filteredNcrs,
    activityFeed,
    charts,
    isLoading,
    error,
    reload: load,
  };
};
